import React, { createContext, useState } from "react";

export interface AlertContextType {
  alert: {
    open: boolean;
    message: string;
    severity: "success" | "error" | "info" | "warning";
  };
  setAlert: React.Dispatch<
    React.SetStateAction<{
      open: boolean;
      message: string;
      severity: "success" | "error" | "info" | "warning";
    }>
  >;
}

const AlertContext = createContext<AlertContextType | undefined>(undefined);

export const AlertProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [alert, setAlert] = useState({
    open: false,
    message: "",
    severity: "success" as "success" | "error" | "info" | "warning",
  });

  const handleSetAlert = (newAlert: any) => {
    setAlert(newAlert);
  };

  return (
    <AlertContext.Provider value={{ alert, setAlert: handleSetAlert }}>
      {children}
    </AlertContext.Provider>
  );
};

export default AlertContext;
